import React from "react";
import { Drawer, Typography, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { StyledButtonMain } from "../../common/Buttons";

interface DataValidationDrawerProps {
    open: boolean;
    onClose: () => void;
    firm: any;
    onVerify: (data: any) => void;
    onEmailClick?: () => void;
    children?: React.ReactNode;
}

const DataValidationDrawer: React.FC<DataValidationDrawerProps> = ({
    open,
    onClose,
    firm,
    onVerify,
    onEmailClick,
    children,
}) => {
    const [formData, setFormData] = React.useState<any>({
        _id: "",
        Employees: "",
        "Annual Revenue": "",
        "Employees 2025": "",
        "Annual Revenue 2025": "",
        "Employees 2024": "",
        "Annual Revenue 2024": "",
    });

    React.useEffect(() => {
        if (firm && open) {
            setFormData({
                _id: firm?._id || "",
                Employees: firm?.Employees || "",
                "Annual Revenue": firm?.["Annual Revenue"] || "",
                "Employees 2025": firm?.["Employees 2025"] || "",
                "Annual Revenue 2025": firm?.["Annual Revenue 2025"] || "",
                "Employees 2024": firm?.["Employees 2024"] || "",
                "Annual Revenue 2024": firm?.["Annual Revenue 2024"] || "",
            });
        }
    }, [firm, open]);

    const handleInputChange = (field: string, value: string) => {
        setFormData((prev: any) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleVerify = () => {
        onVerify(formData);
    };

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <div className="w-[400px] h-full flex flex-col">
                <div className="p-6 flex-1 overflow-y-auto">
                    <div className="flex justify-between items-center mb-6">
                        <Typography variant="h5">Data Validation</Typography>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    {firm && (
                        <div className="space-y-4 pb-4">
                            <div>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Company Name
                                </Typography>
                                <Typography variant="body1">
                                    {firm?.["Company Name"]}
                                </Typography>
                            </div>

                            <div>
                                <Typography variant="subtitle2" color="textSecondary">
                                    City
                                </Typography>
                                <Typography variant="body1">{firm?.City || "-"}</Typography>
                            </div>

                            <div>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Email
                                </Typography>
                                <Typography
                                    variant="body1"
                                    className="cursor-pointer hover:text-blue-600 hover:underline"
                                    onClick={() => {
                                        if (firm?.Email && onEmailClick) {
                                            onEmailClick();
                                        }
                                    }}
                                >
                                    {firm?.Email || "-"}
                                </Typography>
                            </div>
                            <div>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Phone
                                </Typography>
                                <Typography variant="body1">{firm?.Phone || "-"}</Typography>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <TextField
                                        label="Employees"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        value={formData.Employees}
                                        onChange={(e) =>
                                            handleInputChange("Employees", e.target.value)
                                        }
                                    />
                                </div>
                                <div>
                                    <TextField
                                        label="Annual Revenue"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        value={formData["Annual Revenue"]}
                                        onChange={(e) =>
                                            handleInputChange("Annual Revenue", e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <TextField
                                        label="2025 Employees"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        value={formData["Employees 2025"]}
                                        onChange={(e) =>
                                            handleInputChange("Employees 2025", e.target.value)
                                        }
                                    />
                                </div>
                                <div>
                                    <TextField
                                        label="2025 Revenue"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        value={formData["Annual Revenue 2025"]}
                                        onChange={(e) =>
                                            handleInputChange("Annual Revenue 2025", e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <TextField
                                        label="2024 Employees"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        value={formData["Employees 2024"]}
                                        onChange={(e) =>
                                            handleInputChange("Employees 2024", e.target.value)
                                        }
                                    />
                                </div>
                                <div>
                                    <TextField
                                        label="2024 Revenue"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        value={formData["Annual Revenue 2024"]}
                                        onChange={(e) =>
                                            handleInputChange("Annual Revenue 2024", e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                            <div>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Last Validated
                                </Typography>
                                <Typography variant="body1">
                                    {firm?.["last_validated_at"]
                                        ? new Date(firm["last_validated_at"]).toLocaleDateString()
                                        : "Never"}
                                </Typography>
                            </div>

                            <div className="pt-6">
                                <StyledButtonMain
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={handleVerify}
                                    size="large"
                                >
                                    Verify
                                </StyledButtonMain>
                            </div>
                        </div>
                    )}
                </div>
                {children}
            </div>
        </Drawer>
    );
};

export default DataValidationDrawer;
